/* RESPONSIBLE TEAM: team-standalone */
import ContentEditorController from 'embercom/controllers/apps/app/content/edit';
export default ContentEditorController;
